module.exports = __webpack_public_path__ + "img/img-tabs-1-2.aa3d6f43.svg";